import { applicationPortalDialog as fdy } from "./foundry-parts.generated";
/**
 * @fileoverview AppPortalNavigationItem — one category entry in
 * AppPortalNavigation. Shows name + muted count. Modifiers: hover
 * background, selected.
 *
 * Foundry mapping: `application-portal-dialog__menu-label` +
 * `__navigation-item` + `__background-on-hover` + `__selected`.
 */

interface AppPortalNavigationItemProps {
  label: string;
  count: number;
  selected?: boolean;
  onClick?: () => void;
  className?: string;
}

export function AppPortalNavigationItem({
  label,
  count,
  selected = false,
  onClick,
  className,
}: AppPortalNavigationItemProps) {
  return (
    <div data-testid="app-portal-navigation-item"
      className={[
        // Foundry's own parts first — the vendored stylesheet keys on these, so
        // the item's box, padding, hover and selected surface are the product's
        // rather than values retyped from a capture.
        fdy["menu-label"],
        fdy["background-on-hover"],
        selected ? fdy["selected"] : "",
        // Ours, kept because our selectors and tests use them.
        "bp-app-portal-navigation-item",
        selected ? "is-selected" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      tabIndex={0}
      role="button"
      aria-pressed={selected}
      onClick={onClick}
      onKeyDown={(e) => {
        if (onClick && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      {/*
        THE WRAPPER IS PART OF THE SHAPE. Foundry nests
        `menu-label > navigation-item > (label, count)`; ours put the label and
        count directly in the menu-label, one level short. That is not cosmetic:
        `__navigation-item__` is what carries `justify-content: space-between`,
        so without it the count does not sit at the far edge — and it shifted
        every descendant's index path, which is why this subtree accounted for
        the largest block of remaining differences.
      */}
      <span className={fdy["navigation-item"]}>
        <span className="bp-app-portal-navigation-item-label bp6-text-overflow-ellipsis">
          {label}
        </span>
        <span className="bp-app-portal-navigation-item-count bp6-text-muted">{count}</span>
      </span>
    </div>
  );
}
